export default "__VITE_ASSET__AWEvdQyV__"